import Alpine from "alpinejs";
import { Splide } from "@splidejs/splide";

Alpine.data("imageSlider", () => ({
    splide: null,
    splideOptions: {
        type: "loop",
        drag: "free",
        perPage: 3,
        arrows: false,
        isNavigation: false,
        pagination: false,
        breakpoints: {
            1024: {
                perPage: 2,
            },
            640: {
                perPage: 1,
            },
        },
    },
    dialogContent: "",

    init() {
        this.splide = new Splide(this.$refs.slider, this.splideOptions).mount();
    },

    openModal($event) {
        this.dialogContent = $event.target
            .closest(".snap-teasers-horizontal--item")
            .querySelector("template").innerHTML;
        this.$refs.dialog.showModal();
    },

    closeModal($event) {
        // Close if clicking the dialog backdrop or the centering container
        if ($event.target === this.$refs.dialog || $event.target.classList.contains('flex')) {
            this.$refs.dialog.close();
        }
    },
}));
